export default [
  {
    path: '/adDetail',
    name: 'adDetail',
    meta: {
      title: '广告页'
    },
    component: () => import('@/views/adDetail')
  }
]
